<template>
    <DataTable  :value="logs"
                stripedRows
                dataKey="id"
                scrollable
                scrollHeight="60vh"
                lazy
                paginator
                :rows="limit"
                 :rowsPerPageOptions="[5, 10, 20, 50]"
                :totalRecords="logCount"
                @page="pageChanged($event)"
                :loading="loading"
                paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
    >
        <Column field="content_type" header="Content Type"></Column>
        <Column field="object_id" header="Object ID"></Column>
        <Column field="changes" header="Changes">
            <template #body="{data}">
                {{ Object.keys(data.changes).join(', ') }}
            </template>
        </Column>
        <Column field="user" header="User">
            <template #body="{data}">
                {{ data.additional_data.email }}
            </template>
        </Column>
        <Column field="timestamp" header="Timestamp">
            <template #body="{data}">
                {{ parseDate(data.timestamp) }}
            </template>
        </Column>
        <Column name="ip_address" header="IP Address">
            <template #body="{data}">
                {{ data.additional_data.ip_address }}
            </template>
        </Column>

    </DataTable>
</template>
<script setup>
import {useStore} from "vuex";
import {onMounted, ref, computed} from "vue";
import {parseDate} from "@/src/utils/utils";

const store = useStore()

const logCount = ref(0)
const logs = ref([])
const from = ref(0)
const limit = ref(10)

onMounted(async () => {
    await getCount()
    await getLogs()
})

const getCount = async () => {
    logCount.value = await store.dispatch('userStore/getAuditLogsCount')
}
const getLogs = async () => {
    logs.value = await store.dispatch('userStore/getAuditLogs', {from: from.value, count: limit.value})
}

const loading = computed(() => store.getters.isLoading(['GET_AUDIT_LOGS', 'AUDIT_LOGS_COUNT']))

const pageChanged = async (event) => {
    from.value = event.first
    limit.value = event.rows
    await getLogs()
}
</script>